import React, { useRef, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useClickOutside } from '../../hooks/useClickOutside';

const slugify = (label) => label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

// Desktop nav item with a hover/click dropdown of child links.
export const NavDropdown = ({ item, className }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useClickOutside(ref, () => setOpen(false));
  const slug = slugify(item.label);

  return (
    <div ref={ref} className="relative" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <button
        type="button"
        data-testid={`nav-${slug}`}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        className={`${className} inline-flex items-center gap-1`}
      >
        {item.label}
        <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div role="menu" data-testid={`nav-${slug}-menu`} className={`absolute left-1/2 -translate-x-1/2 top-full pt-3 ${item.children.length > 5 ? 'w-[36rem]' : 'w-72'}`}>
          <div className={`bg-sand-50 rounded-2xl shadow-2xl border border-gray-100 overflow-hidden py-2 ${item.children.length > 5 ? 'grid grid-cols-2' : ''}`}>
            {item.children.map((child) => (
              <a
                key={child.label}
                role="menuitem"
                href={child.href}
                target={child.internal ? undefined : '_blank'}
                rel={child.internal ? undefined : 'noopener noreferrer'}
                data-testid={`nav-${slug}-${slugify(child.label)}`}
                className="block px-5 py-3 text-[#143160] hover:bg-gold-100 transition-colors"
              >
                <span className="block text-sm font-bold">{child.label}</span>
                {child.sub && <span className="block text-xs text-neutral-500">{child.sub}</span>}
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
